import client, { mock, isRealApiEnabled } from "./client";
import { settings } from "./mocks/settings";

const clone = (value) => JSON.parse(JSON.stringify(value));

/**
 * @endpoint GET /api/v1/settings
 */
export function getSettings() {
  if (isRealApiEnabled()) return client.get("/v1/settings");
  return mock(clone(settings));
}

/**
 * @endpoint PATCH /api/v1/settings
 * Accepts a partial payload — only the provided top-level sections are
 * replaced.
 */
export function updateSettings(payload = {}) {
  if (isRealApiEnabled()) return client.patch("/v1/settings", payload);
  if (payload.outOfStock) {
    settings.outOfStock = clone(payload.outOfStock);
  }
  if (payload.reorder) {
    settings.reorder = clone(payload.reorder);
  }
  if (payload.outOfStockDefaultWeeks !== undefined) {
    settings.outOfStockDefaultWeeks = payload.outOfStockDefaultWeeks;
  }
  if (Array.isArray(payload.outOfStockItemSpecific)) {
    settings.outOfStockItemSpecific = clone(payload.outOfStockItemSpecific);
  }
  if (payload.reorderDefaultWeeks !== undefined) {
    settings.reorderDefaultWeeks = payload.reorderDefaultWeeks;
  }
  if (Array.isArray(payload.reorderItemSpecific)) {
    settings.reorderItemSpecific = clone(payload.reorderItemSpecific);
  }
  return mock(clone(settings));
}
